import React, { useState } from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import BsModal from '../Common/BsModal';
import { useTheme } from '../../DataStore/ThemeContext';
import Notification from '../Common/Notification';
import ajaxLedger from '../../util/remote/ajaxLedger';
import { useSchoolTransactions } from '../../DataStore/FeesTransactionContext';
import { useLedger } from '../../DataStore/LedgerContext';
import { useJournal } from '../../DataStore/JournalContext';

const AlertDeleteLedger = ({title, alertDescription, notes, show, handleClose, selection}) => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();
    const {refresh: refreshSchool, resetSelectedIds} = useSchoolTransactions();
    const {refresh: refreshLedgers} = useLedger();
    const {refresh: refreshJournals} = useJournal();

  
    const refreshSystem = async ()=>{

        resetSelectedIds();
        await refreshSchool();
        await refreshLedgers();
        await refreshJournals();

    }

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxLedger.deleteLedger(selection);
        setLoading(false);
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>)
            await refreshSystem();
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)
        }
        handleClose();
    }

    return (
        <BsModal
            show={show}
            onClose={handleClose}
            title={title || "Delete Transaction"}
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>
                    </>}
                </>
            }
        >


            <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>{alertDescription}</h5>

                {notes && <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b> {notes}
                </p>}
           
            </div>
          

        </BsModal>
    );
};

export default AlertDeleteLedger;
